export default{
  carriers: (state) => state.carriers,
  carrier: (state) => state.carrier
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/getters.js